import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import PalavrasDiretorExecutivo from '@/components/PalavrasDiretorExecutivo'
import Arrecadacao from '@/components/Arrecadacao'
import Distribuicao from '@/components/Distribuicao'
import AnaliseDiretorDeOperacoes from '@/components/AnaliseDiretorDeOperacoes'
import OsNumeros2025 from '@/components/OsNumeros2025'
import AtividadesPrincipais from '@/components/AtividadesPrincipais'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/Hotsite/Relatorio_Anual/2025/eng/',
  // base: '/vialactea/relatorio_ubc2025/eng/',
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/FewWordFromOurCEO', name: 'FewWordFromOurCEO', component: PalavrasDiretorExecutivo },
    { path: '/Collections', name: 'Collections', component: Arrecadacao },
    { path: '/Distributions', name: 'Distributions', component: Distribuicao },
    { path: '/OurChiefOperatingOfficersAnalysiss', name: 'OurChiefOperatingOfficersAnalysiss', component: AnaliseDiretorDeOperacoes },
    { path: '/UBCNumbersIn2025', name: 'UBCNumbersIn2025', component: OsNumeros2025 },
    { path: '/MainActivities', name: 'MainActivities', component: AtividadesPrincipais },
  ]
})
